var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "reimagine-portal-icon",
      class: { "responsive-reimagine-portal-icon": _vm.responsive },
      attrs: {
        viewBox: "0 0 218 70",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
      },
    },
    [
      _c("title", [_vm._v("logo with CP Copy")]),
      _vm._v(" "),
      _c("defs", [
        _c("polygon", {
          attrs: {
            id: "path-1",
            points: "0 32.3900262 27.2258151 32.3900262 27.2258151 0 0 0",
          },
        }),
        _vm._v(" "),
        _c("polygon", {
          attrs: {
            id: "path-3",
            points: "0 40.6238532 216 40.6238532 216 0 0 0",
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "-",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "EXAMPLE:-Welcome-page",
                transform: "translate(-140.000000, -38.000000)",
              },
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "logo-with-CP-Copy",
                    transform: "translate(140.000000, 38.000000)",
                  },
                },
                [
                  _c("g", { attrs: { id: "reimagine-logo" } }, [
                    _c(
                      "g",
                      {
                        attrs: {
                          id: "Group-3",
                          transform: "translate(0.000267, 7.928800)",
                        },
                      },
                      [
                        _c("mask", { attrs: { id: "mask-2", fill: "white" } }, [
                          _c("use", { attrs: { "xlink:href": "#path-1" } }),
                        ]),
                        _vm._v(" "),
                        _c("g", { attrs: { id: "Clip-2" } }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M20.7849567,24.0526795 L16.1487732,27.2424993 L16.1569227,24.0419273 L20.7849567,24.0526795 Z M3.35852088,3.2830099 L21.4722346,3.32333066 L13.6142658,8.673447 C13.1524585,8.98705289 12.8762796,9.5049506 12.8753741,10.059585 L12.85002,20.7562336 L3.31867867,20.7356252 L3.35852088,3.2830099 Z M16.1858989,10.9018408 L23.8953649,5.65207833 L23.8600502,20.7813221 L16.1632612,20.7642978 L16.1858989,10.9018408 Z M27.2258151,1.29922869 C27.2276218,0.614671852 26.6653034,0.0564533822 25.9725924,0.0546613486 L1.30755299,-1.6622776e-15 C0.615747481,-0.00178771021 0.0507126191,0.553742709 0.0489016099,1.23919557 L-2.68099508e-13,22.7642073 C-0.001806647,23.4496602 0.560511702,24.0069826 1.25322271,24.0087746 L12.8427759,24.0347591 L12.8264768,31.1473405 C12.8246658,31.8310014 13.3860787,32.3883238 14.0769787,32.3901236 C14.3332365,32.3910119 14.5813447,32.3139544 14.7941383,32.1679037 L26.6127842,24.0356551 C26.9586869,23.7982107 27.1678585,23.4057553 27.168764,22.9873155 L27.1696695,22.9021939 C27.1714805,22.8762094 27.177819,22.8511209 27.177819,22.8242404 L27.2258151,1.29922869 Z",
                            id: "Fill-1",
                            fill: "#FEFEFE",
                            mask: "url(#mask-2)",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M50.2828921,9.95814966 C50.2646801,9.95725872 50.2474265,9.95814966 50.2292144,9.96082249 C49.9090652,9.93231233 49.5774136,9.90825688 49.2179647,9.90825688 C47.5472459,9.90825688 44.9783839,10.3207633 43.5425051,12.4412064 L43.5425051,12.4394245 C43.5099151,12.4821898 43.4552788,12.508918 43.3939329,12.5080271 C43.2952042,12.5062452 43.2166047,12.4305151 43.2185218,12.3378571 L43.2185218,12.3369661 L43.2166047,12.338748 L43.2166047,10.3145267 L43.2156462,10.3136357 C43.2127706,10.1844491 43.1006225,10.0784269 42.9597185,10.0757541 C42.95876,10.0757541 42.9578014,10.076645 42.9578014,10.076645 L42.9568429,10.0757541 L37.9197647,10.0757541 L37.9188062,10.076645 L37.9178476,10.0757541 C37.7740681,10.0739722 37.6561688,10.1791034 37.6523347,10.3109629 C37.6523347,10.3118538 37.6523347,10.3136357 37.6513761,10.3145267 C37.6513761,10.3163085 37.6523347,10.3180904 37.6523347,10.3189814 L37.6523347,29.4724632 L37.6542517,29.475136 L37.6542517,29.4778089 C37.6513761,29.6123412 37.7663998,29.7228181 37.9111379,29.7247706 C37.9312671,29.7254909 37.9523547,29.7228181 37.9715254,29.7183633 L43.1054152,29.7183633 C43.1217102,29.7219271 43.1399223,29.7247706 43.1581343,29.7247706 C43.3028725,29.7272728 43.4217302,29.6203597 43.4246058,29.4867183 C43.4246058,29.4786998 43.4236473,29.4715723 43.4226888,29.4644447 L43.4226888,20.7465724 C43.4226888,16.507468 45.9234951,15.1879821 48.8479719,15.1879821 C49.274518,15.1879821 49.7259859,15.2147104 50.2196291,15.2922224 L50.2196291,15.2922224 C50.23209,15.2948952 50.2455094,15.2966771 50.2589289,15.2975681 C50.4027085,15.3038047 50.5244418,15.2004553 50.5311516,15.065923 C50.5321101,15.0614683 50.530193,15.0561226 50.530193,15.050777 L50.5321101,15.049886 L50.5321101,10.2076136 L50.5311516,10.2067226 C50.5349857,10.0748631 50.4247547,9.96438626 50.2828921,9.95814966",
                        id: "Fill-4",
                        fill: "#FEFEFE",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M57.9897126,17.4549141 L57.9897126,17.4549141 L58.269293,17.4549141 C58.1436185,17.4251441 58.0534606,17.3228096 58.0316042,17.2018689 C58.0306935,17.199078 58.0297828,17.1953567 58.0297828,17.1925658 C58.0288721,17.1907052 58.0288721,17.1888445 58.0288721,17.1869839 C58.023408,17.151632 58.0252294,17.1134892 58.0334255,17.0762767 C58.3230235,15.2798422 59.8502428,13.404331 62.483945,13.404331 C65.3890313,13.404331 66.7204533,15.1989049 66.947214,17.0688342 L66.9453926,17.0688342 C66.9490353,17.0846495 66.9508567,17.1013951 66.9517674,17.1162801 C66.9526781,17.121862 66.9526781,17.1265136 66.9535888,17.1311651 C66.9544995,17.1507017 66.9535888,17.169308 66.9508567,17.1869839 C66.9508567,17.1888445 66.949946,17.1907052 66.949946,17.1916355 C66.9490353,17.1953567 66.9490353,17.199078 66.9481247,17.2018689 C66.9262682,17.3228096 66.8351997,17.4251441 66.7104358,17.4549141 L66.9781773,17.4539838 L66.9781773,17.4549141 L57.9897126,17.4549141 Z M72.3302752,19.555561 C72.3302752,12.9577808 68.6119468,8.91743119 62.4019833,8.91743119 C57.2538788,8.91743119 52.5137615,13.1764043 52.5137615,19.7332507 C52.5137615,26.6650133 57.3768214,30.7155963 62.8928427,30.7155963 C67.6821371,30.7155963 70.8212696,27.93303 71.9414126,24.5318055 C71.9432339,24.5290145 71.9441446,24.5262236 71.9450553,24.5225023 C71.945966,24.5187811 71.9477874,24.5150598 71.9486981,24.5113386 L71.9486981,24.5113386 C71.9596263,24.4797079 71.9669118,24.4452864 71.9669118,24.4099345 C71.9669118,24.2713178 71.8776646,24.1531681 71.7547221,24.1131646 L71.7538114,24.1131646 L71.7529007,24.1103737 L67.7868659,22.9074789 C67.7859552,22.9074789 67.7850445,22.9065486 67.7832232,22.9056183 C67.777759,22.9037576 67.7713842,22.901897 67.7650094,22.9009667 C67.7413316,22.8944545 67.7167431,22.8916636 67.6903332,22.8916636 C67.5673907,22.8916636 67.4599298,22.9670189 67.4134849,23.0758655 C67.4125742,23.0767959 67.4125742,23.0777262 67.4116635,23.0786565 L67.4098421,23.0795868 C66.7186319,24.7774081 65.3444077,25.944951 62.9329128,25.944951 C60.2928359,25.944951 58.0844239,24.0396699 57.878609,21.4245599 C57.9150364,21.3464136 57.9806058,21.2850129 58.0625675,21.2571035 L71.9559835,21.2571035 C71.9596263,21.2571035 71.9623583,21.2580338 71.9650904,21.2580338 C72.1262817,21.2580338 72.2574204,21.1287203 72.2674379,20.9659155 L72.2692593,20.9640549 C72.2929371,20.637515 72.3302752,20.0932819 72.3302752,19.555561 L72.3302752,19.555561 Z",
                        id: "Fill-6",
                        fill: "#FEFEFE",
                      },
                    }),
                    _vm._v(" "),
                    _c("mask", { attrs: { id: "mask-4", fill: "white" } }, [
                      _c("use", { attrs: { "xlink:href": "#path-3" } }),
                    ]),
                    _vm._v(" "),
                    _c("g", { attrs: { id: "Clip-9" } }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M76.2265976,29.7247706 L80.3219243,29.7247706 L80.3219243,10.1651884 L76.2265976,10.1651884 L76.2265976,29.7247706 Z M78.2524722,0 C79.9258523,0 81.2477064,1.21967954 81.2477064,2.7648454 C81.2477064,4.26977257 79.9258523,5.48945211 78.2524722,5.48945211 C76.6226696,5.48945211 75.3027523,4.26977257 75.3027523,2.7648454 C75.3027523,1.21967954 76.6226696,0 78.2524722,0 L78.2524722,0 Z",
                        id: "Fill-8",
                        fill: "#FEFEFE",
                        mask: "url(#mask-4)",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M84.2201835,29.7247706 L84.2201835,10.4681548 L87.8781735,10.4681548 L87.8781735,13.0308324 C89.0972056,10.9083262 91.5361635,9.90825688 93.8115709,9.90825688 C96.2505288,9.90825688 98.6081583,11.0694289 99.66364,13.5519952 C101.208879,10.7885996 103.728272,9.90825688 106.208341,9.90825688 C109.621452,9.90825688 112.954128,12.1901051 112.954128,17.2344687 L112.954128,29.7247706 L109.174593,29.7247706 L109.174593,17.6350246 C109.174593,15.1128428 107.91445,13.2315505 105.028632,13.2315505 C102.346583,13.2315505 100.517141,15.3126806 100.517141,18.0751959 L100.517141,29.7247706 L96.6973881,29.7247706 L96.6973881,17.6350246 C96.6973881,15.1524582 95.478356,13.2315505 92.5523215,13.2315505 C89.8282674,13.2315505 87.9997192,15.2334498 87.9997192,18.1156917 L87.9997192,29.7247706 L84.2201835,29.7247706 Z",
                        id: "Fill-10",
                        fill: "#FEFEFE",
                        mask: "url(#mask-4)",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M129.682522,21.7168115 L129.682522,20.82141 L123.686974,21.7168115 C122.055575,21.9603607 120.83225,22.8978461 120.83225,24.6483559 C120.83225,26.1150236 122.055575,27.4993142 124.013433,27.4993142 C127.154257,27.4993142 129.682522,25.9914582 129.682522,21.7168115 M122.871723,18.9070417 L128.173097,18.1343102 C129.356063,17.9704518 129.682522,17.3597879 129.682522,16.6676426 C129.682522,14.7541697 128.417941,13.1657274 125.441244,13.1657274 C122.74975,13.1657274 121.240324,14.8347558 120.99548,17.1162387 L117.324608,16.2611303 C117.732682,12.5138752 121.117454,9.90825688 125.359629,9.90825688 C131.232306,9.90825688 133.515727,13.247209 133.515727,17.0750503 L133.515727,26.887755 C133.515727,28.5979718 133.679853,29.6160433 133.761468,30.1049325 L130.008084,30.1049325 C129.92647,29.6160433 129.805393,28.8827095 129.805393,27.4581258 C128.948886,28.8424164 126.991028,30.7155963 123.483386,30.7155963 C119.486055,30.7155963 116.917431,27.947015 116.917431,24.8516121 C116.917431,21.3496969 119.486055,19.3959309 122.871723,18.9070417",
                        id: "Fill-11",
                        fill: "#FEFEFE",
                        mask: "url(#mask-4)",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M151.900002,19.2490109 C151.900002,15.5367613 149.622679,13.1017221 146.329636,13.1017221 C142.955229,13.1017221 140.677906,15.5367613 140.677906,19.2490109 C140.677906,23.0016398 142.87297,25.3971776 146.329636,25.3971776 C149.622679,25.3971776 151.900002,22.9612606 151.900002,19.2490109 L151.900002,19.2490109 Z M140.433812,29.6685909 C140.718142,32.3432717 142.791605,34.3780304 145.760976,34.3780304 C149.867668,34.3780304 151.737272,32.3028925 151.737272,28.150861 L151.737272,25.3971776 C150.802023,27.1527934 148.68743,28.5493858 145.760976,28.5493858 C140.555412,28.5493858 136.77418,24.6782529 136.77418,19.2490109 C136.77418,14.0602883 140.393576,9.90825688 145.760976,9.90825688 C148.768795,9.90825688 150.802023,11.0257064 151.777507,12.9410832 L151.777507,10.2672803 L155.559633,10.2672803 L155.559633,28.0306014 C155.559633,32.9015575 153.119581,37.6513761 145.760976,37.6513761 C140.880872,37.6513761 137.22124,34.617672 136.733945,30.5068975 L140.433812,29.6685909 Z",
                        id: "Fill-12",
                        fill: "#FEFEFE",
                        mask: "url(#mask-4)",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M159.457074,29.7247706 L163.553068,29.7247706 L163.553068,10.1651884 L159.457074,10.1651884 L159.457074,29.7247706 Z M161.483279,0 C163.155963,0 164.477064,1.21967954 164.477064,2.7648454 C164.477064,4.26977257 163.155963,5.48945211 161.483279,5.48945211 C159.853211,5.48945211 158.53211,4.26977257 158.53211,2.7648454 C158.53211,1.21967954 159.853211,0 161.483279,0 L161.483279,0 Z",
                        id: "Fill-13",
                        fill: "#FEFEFE",
                        mask: "url(#mask-4)",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M173.273809,29.7247706 L169.431193,29.7247706 L169.431193,10.4681548 L173.191994,10.4681548 L173.191994,13.2315505 C174.62331,10.8290953 176.953694,9.90825688 179.243619,9.90825688 C183.944845,9.90825688 186.275229,13.2315505 186.275229,17.5144176 L186.275229,29.7247706 L182.432613,29.7247706 L182.432613,18.1544268 C182.432613,15.472903 181.287201,13.3107813 177.852761,13.3107813 C174.828297,13.3107813 173.273809,15.6736211 173.273809,18.5954785 L173.273809,29.7247706 Z",
                        id: "Fill-14",
                        fill: "#FEFEFE",
                        mask: "url(#mask-4)",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M204.071005,18.2969123 C203.989287,15.4872634 202.151977,13.288252 198.681204,13.288252 C195.454688,13.288252 193.494352,15.7719888 193.331814,18.2969123 L204.071005,18.2969123 Z M207.950368,24.5268477 C206.848521,27.9874254 203.703723,30.7155963 199.130205,30.7155963 C193.861634,30.7155963 189.247706,26.8870244 189.247706,20.2505942 C189.247706,14.1030323 193.699096,9.90825688 198.639896,9.90825688 C204.68434,9.90825688 208.073394,14.0618456 208.073394,20.1700116 C208.073394,20.6579844 208.032086,21.1468526 207.991676,21.3912866 L193.20789,21.3912866 C193.290506,24.8921557 195.82197,27.3356012 199.130205,27.3356012 C202.315414,27.3356012 203.907569,25.5842713 204.643032,23.3861553 L207.950368,24.5268477 Z",
                        id: "Fill-15",
                        fill: "#FEFEFE",
                        mask: "url(#mask-4)",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "text",
                    {
                      attrs: {
                        id: "Community-Portal",
                        "font-family": "LL Circular Book Sub",
                        "font-size": "19",
                        "font-weight": "normal",
                        "letter-spacing": "1",
                        fill: "#FFFFFF",
                      },
                    },
                    [
                      _c("tspan", { attrs: { x: "37", y: "58" } }, [
                        _vm._v("Community Portal"),
                      ]),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }